import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { OfferListResponse, SET_LOADER } from 'dealer-reducers'

import { FETCH_OFFERS_SUCCESS, FETCH_OFFERS, FETCH_OFFERS_ERROR } from '../redux/paginatedOffersReducer'
import { RootReducer } from 'src/redux/rootReducer'
import { OffersListTab } from 'dealer-types'
import track from '../helpers/track'

interface FetchOffersResponse extends Response, OfferListResponse {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchPaginatedOffersFlow(): Generator<any, void, any> {
  const tab = yield select((state: RootReducer) => state.offersListReducer.tab)
  const filters = yield select((state: RootReducer) => state.tableToolsReducer.filters[tab as OffersListTab])
  const buyNowOnly = yield select(
    (state: RootReducer) => state.tableToolsReducer.filters[tab as OffersListTab].buyNowFiler
  )
  const currentPage = yield select((state: RootReducer) => state.paginatedOffersReducer.currentPage)

  const endpoint = getEndPoint(tab)

  try {
    yield put(SET_LOADER(true))

    const response: FetchOffersResponse = yield call(apiCall, {
      endpoint,
      method: GET,
      params: {
        page: currentPage,
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        filters: { ...filters, buy_now_only: buyNowOnly ? 'true' : '' }
      }
    })

    yield put(
      FETCH_OFFERS_SUCCESS({
        offers: response.offers,
        totalPages: response.total_pages,
        totalCount: response.total_count
      })
    )
  } catch (error) {
    track('dealer_fetch_offers_fail', {
      tab,
      endpoint,
      page: currentPage,
      pagination: 'paginated',
      error: String(error),
      filters_snapshot: filters
    })
    yield put(FETCH_OFFERS_ERROR())
  } finally {
    yield put(SET_LOADER(false))
  }
}

const getEndPoint = (tab: OffersListTab): string => {
  if (tab === 'archive_accepted' || tab === 'sold') {
    return `/api/v2/archive_offers/${tab}`
  }
  return `/api/v2/offers/${tab}`
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchPaginatedOffersSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_OFFERS, FetchPaginatedOffersFlow)
}
